export const CHECK_VISITOR_STATUS = "CHECK_VISITOR_STATUS";
export const CLEAR_VISITOR_STATUS = "CLEAR_VISITOR_STATUS";
export const PARKING_ZONE_NOT_EXIST = "PARKING_ZONE_NOT_EXIST";
export const SIGN_IN_VISITOR = "SIGN_IN_VISITOR";
export const VISITOR_ALREADY_SIGNED_IN = "VISITOR_ALREADY_SIGNED_IN";
export const VISITOR_WAITING_FOR_FREEZE_TIME_TO_EXPIRE =
  "VISITOR_WAITING_FOR_FREEZE_TIME_TO_EXPIRE";
